export const parseMarkdown = (text) => {
  const blocks = [];
  const lines = text.split('\n');
  let i = 0;
  while (i < lines.length) {
    const line = lines[i];
    if (line.trim().startsWith('|')) {
      const tableLines = [];
      while (i < lines.length && lines[i].trim().startsWith('|')) {
        tableLines.push(lines[i]);
        i++;
      }
      blocks.push({ type: 'table', raw: tableLines });
      continue;
    }
    if (line.trim() !== '') {
      blocks.push({ type: 'paragraph', raw: line });
    } else if (blocks.length > 0 && blocks[blocks.length - 1]?.type === 'spacer') {
      // skip
    } else if (blocks.length > 0) {
      blocks.push({ type: 'spacer' });
    }
    i++;
  }
  return blocks;
};

export const parseTable = (tableLines) => {
  const rows = tableLines
    .filter(l => !l.trim().match(/^\|[-| :]+\|$/))
    .map(l => l.trim().replace(/^\|/, '').replace(/\|$/, '').split('|').map(cell => cell.trim()));
  return { headers: rows[0] || [], body: rows.slice(1) };
};

export const parseInline = (text) => {
  const tokens = [];
  const regex = /\[([^\]]+)\]\((https?:\/\/[^)]+)\)|\*\*([^*]+)\*\*|([^*[]+|\[(?!\[)|\*(?!\*))/g;
  let match;
  while ((match = regex.exec(text)) !== null) {
    if (match[1] && match[2]) tokens.push({ type: 'link', label: match[1], href: match[2] });
    else if (match[3]) tokens.push({ type: 'bold', text: match[3] });
    else if (match[4]) tokens.push({ type: 'text', text: match[4] });
  }
  return tokens;
};